import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FacilitiesFormService } from '../../facilities-form.service';
import { ApplicationSectionKeys } from '../../../../constants/app.constants';
import { WaterDeviceObject } from '../../facilities-form.domain';

@Component({
  selector: 'app-water-device',
  templateUrl: './water-device.component.html',
  styleUrls: ['./water-device.component.scss'],
})
export class WaterDeviceComponent implements OnInit {
  @Input() isReadOnly: boolean = false;
  @Input() waterDeviceData: WaterDeviceObject = null;
  @Input() displayDeleteButton: boolean = false;

  @Input() parentIndex: number;
  @Input() currentIndex: number = 0;

  @Output() deleteComponent = new EventEmitter<any>();

  applicationSection = ApplicationSectionKeys.technicalData.waterDevice;

  waterDeviceFG: FormGroup;

  constructor(private facilitiesFormService: FacilitiesFormService) {}

  ngOnInit(): void {
    this.waterDeviceFG = new FormGroup({
      deviceId: new FormControl(this.waterDeviceData?.deviceId || ''),
      facilityId: new FormControl(this.waterDeviceData?.facilityId || ''),
      customFields: new FormControl(this.waterDeviceData?.customFields || {}, Validators.required),
    });

    this.facilitiesFormService.manageWaterDeviceFormData({
      component: 'waterDevice',
      formData: this.waterDeviceFG,
      index: this.currentIndex,
      parentIndex: this.parentIndex,
    });
  }
}
